import React, { useEffect, useState, useRef } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import { saveAs } from 'file-saver';
import { format, parseISO, set } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';
import {
  MDBContainer,
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBCollapse,
  MDBIcon,
  MDBCard,
  MDBListGroup,
  MDBListGroupItem,
  MDBCardText,
  MDBCardTitle,
  MDBCardT,
  MDBTooltip,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalFooter,
  MDBSpinner,
  MDBInput,
  MDBCardBody,
  MDBDropdown,
  MDBDropdownMenu,
  MDBDropdownToggle,
  MDBDropdownItem,
  MDBNavbarNav,
  MDBFileInput,
  MDBAlert,
} from 'mdbreact';
import NavBar from '../../../components/NavBar';
import api from '../../../services/api';
import { toast } from 'react-toastify';
import { ToastContainer } from 'react-toastify';
import { getData } from '../../../services/auth';
import { ModalRelatorioLeitura } from '../../../components/Relatos/PDF/modalLeitura';

const CardRelato = ({ item, onUpdate, onDelete }) => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [relatoText, setRelatoText] = useState(item.relato || '');
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [loadingFile, setLoadingFile] = useState(false);
  const [currentUser, setCurrentUser] = useState(null); // Usuário atual
  const [fileName, setFileName] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [isRead, setIsRead] = useState(false);
  const [createdAt, setCreatedAt] = useState({});
  const [abreModalRelatorio, setAbreModalRelatorio] = useState(false);
  const [relatoSelecionado, setRelatoSelecionado] = useState(null);
  const [PDFSelecionado, setPDFSelecionado] = useState(null);

  const isMounted = useRef(true);

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  const toggleEditModal = () => {
    setIsEditModalOpen(!isEditModalOpen);
    setRelatoText(item.relato || '');
    setFileName(item?.relato_pdf?.nome ? item.relato_pdf.nome : '');
    setSelectedPDF(null);
  };

  const handleSaveEdit = async () => {
    try {
      setLoadingFile(true);
      const formData = new FormData();
      formData.append('relato', relatoText);
      if (selectedPDF) {
        formData.append('file', selectedPDF);
      }
      if (isDeleting) {
        const responseDeleting = await api.delete(`/relatos/${item.id}/pdf`);
        setIsDeleting(false);
        setFileName('');
        setSelectedPDF(null);
        setCreatedAt({});
        setIsRead(false);
      }
      const response = await api.patch(`/relatos/${item.id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      const updatedRelato = response.data.relato;
      const responseRelato = updatedRelato.RelatoPdf;
      onUpdate(item.id);
      setLoadingFile(false);
      setTimeout(toggleEditModal, 1000);
      toast.success('Relato atualizado com sucesso!');
    } catch (error) {
      setLoadingFile(false);
      console.error('Erro ao salvar edição:', error);
    }
  };

  const handleDelete = async () => {
    try {
      await api.delete(`/relatos/${item.id}`);
      onDelete(item.id);
    } catch (error) {
      console.error('Erro ao excluir relato:', error);
      alert('Erro ao excluir o relato. Tente novamente.');
    }
  };

  const handleFileChange = (file) => {
    if (file && file.type === 'application/pdf') {
      setSelectedPDF(file);
    } else {
      setSelectedPDF(null);
      alert('Selecione um arquivo PDF válido.');
    }
  };

  const downloadFile = (idRelato,id) => {
    api
      .get('/relato-download', {
        params: { id: id },
        responseType: 'blob',
      })
      .then((blob) => {
        saveAs(blob.data, 'relato.pdf');
        setIsRead(true);
        onUpdate(idRelato); // Atualiza o relato após o download
      })
      .catch((error) => {
        console.error('Erro ao baixar PDF:', error);
        alert('Erro ao baixar o PDF. Tente novamente.');
      });
  };

  useEffect(() => {
    const userData = getData();
    if (userData) {
      setCurrentUser(userData);
    } else {
      console.error('Usuário não encontrado nos dados de autenticação.');
    }

    const isRead = item.relato_pdf?.relato_pdf_leituras?.some(
      (leitura) => leitura.usuario_id === userData?.id
    );

    const leitura = item.relato_pdf?.relato_pdf_leituras?.find(
      (leitura) => leitura.usuario_id === userData?.id
    );
    const createdAt = leitura ? new Date(leitura.created_at).toLocaleString() : null;
    setCreatedAt(createdAt);
    setIsRead(isRead);
  }, []);

  useEffect(() => {
    if (isRead && !createdAt) {
      api.get(`/relatos/${item.id}`).then((response) => {
        const leitura = response.data.relato_pdf?.relato_pdf_leituras?.find(
          (leitura) => leitura.usuario_id === currentUser?.id
        );
        if (leitura) {
          setCreatedAt(new Date(leitura.created_at).toLocaleString());
        }
      });
    }
  }, [isRead]);
  const confirmDelete = () => {
    const handleDeleteRelato = () => {
      toast.success('Item excluído com sucesso!', {
        position: 'top-right',
        autoClose: 3000,
      });
    };

    toast(
      ({ closeToast }) => (
        <>
          <MDBContainer className='pt-3 pb-20'>
            <MDBRow>
              <MDBCol size='12' className='text-center'>
                  Confirmar exclusão?
              </MDBCol>
            </MDBRow>
            <MDBRow>
              <MDBCol size='12' className='text-center'>
                <MDBBtn color="success" className="mr-2" size='sm' onClick={() => {
                  handleDeleteRelato();
                  handleDelete();
                  closeToast();
                }}>
                  Sim
                </MDBBtn>
                <MDBBtn color="danger" className='mr-2' size='sm' onClick={closeToast}>Não</MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBContainer>
        </>
      ),
      {
        position: 'top-center',
        autoClose: false, // Não fecha automaticamente
        closeOnClick: false, // Não fecha ao clicar fora
        draggable: false, // Não permite arrastar
      }
    );
  };

  const abreModalLeitura = (bool, pdf = null) => {
    if (isMounted.current) {
      setAbreModalRelatorio(bool);
      setPDFSelecionado(pdf);
    }
  };

  return (
    <>
      <MDBCard className="mt-3" key={item.id}>
        <MDBCardTitle
          style={{
            backgroundColor: 'rgba(0,0,0,0.04)',
            borderBottom: '1px solid rgba(0,0,0,0.1)',
          }}
          className="text-center p-2 h5-responsive"
        >
          {/* somente usuario que criou pode editar ou excluir */}
          {item.usuario_id === currentUser?.id && (
            <MDBNavbarNav className="d-flex flex-row float-right mr-1" right>
              <MDBDropdown>
                <MDBDropdownToggle tag="a" className="hidden-arrow nav-link" style={{ cursor: 'pointer' }}>
                  <MDBIcon icon="ellipsis-v" />
                </MDBDropdownToggle>
                <MDBDropdownMenu right>
                  <MDBDropdownItem onClick={confirmDelete}>
                    <MDBIcon far icon="trash-alt" className="mr-2" />
                    Excluir
                  </MDBDropdownItem>
                  <MDBDropdownItem onClick={toggleEditModal}>
                    <MDBIcon far icon="edit" className="mr-2" />
                    Editar
                  </MDBDropdownItem>
                  <ToastContainer />
                </MDBDropdownMenu>

              </MDBDropdown>

            </MDBNavbarNav>
          )}

          <MDBRow>
            <MDBCol size="12" md="4">
              <span>Gerência:</span> <br />
              <span className="font-weight-bolder">{item.lotacao.gerencia.nome}</span>
              <div style={{ borderBottom: '1px solid gray' }} className="d-flex d-md-none my-2" />
            </MDBCol>
            <MDBCol size="12" md="4">
              <span>Agente:</span> <br />
              <span className="font-weight-bolder">{item.usuario.nome_social}</span>
              <div style={{ borderBottom: '1px solid gray' }} className="d-flex d-md-none my-2" />
            </MDBCol>
            <MDBCol size="12" md="4">
              <span>Criação:</span> <br />
              <span className="font-weight-bolder">
                {format(
                  zonedTimeToUtc(
                    new Date(item.createdAt),
                    'America/Sao_Paulo'
                  ),
                  'dd/MM/yyyy - HH:mm'
                )}
              </span>
            </MDBCol>
          </MDBRow>
        </MDBCardTitle>
        <MDBCardBody>
          {item.arrayRelato.map((linha, index) => (
            <MDBRow className="mx-2" key={index}>
              <p style={{ width: '100%', wordWrap: 'break-word' }}>{linha}</p>
              <br />
            </MDBRow>
          ))}

          <MDBRow end className="mx-2">
            {item.relato_pdf ? (
              <MDBTooltip domElement tag="span" material placement="top">
                <div>
                  <MDBDropdown>
                    <MDBDropdownToggle tag="div" style={{ cursor: 'pointer' }} className="primary-text cursor-pointer ml-1">
                      <MDBIcon far icon="file-pdf" style={{ color: isRead ? '' : 'green' }} />
                  <span className="ml-2" style={{ color: isRead ? '' : 'green' }}>Arquivo PDF</span>
                    </MDBDropdownToggle>
                    <MDBDropdownMenu right>
                      <MDBDropdownItem onClick={() => downloadFile(item.id, item.relato_pdf_id)}>
                        <i className="fa fa-download mr-2"></i>
                        Download PDF
                      </MDBDropdownItem>
                      <MDBDropdownItem onClick={() => abreModalLeitura(true, item.relato_pdf)}>
                        <MDBIcon far icon="file-alt" className="mr-2" />
                        Relatório de Leitura
                      </MDBDropdownItem>
                    </MDBDropdownMenu>
                  </MDBDropdown>
                </div>

                <span className="font-weight-bolder">
                  {isRead
                    ? `Download feito em ${createdAt}`
                    : 'Download PDF da Denúncia'}
                </span>
              </MDBTooltip>
            ) : null}
          </MDBRow>

        </MDBCardBody>
      </MDBCard>

      {/* Modal de Edição */}
      <MDBModal isOpen={isEditModalOpen} toggle={toggleEditModal}>
        <MDBModalHeader toggle={toggleEditModal}>Editar Relato</MDBModalHeader>
        <MDBModalBody>
          <MDBInput
            type="textarea"
            label="Relato"
            value={relatoText}
            onChange={(e) => setRelatoText(e.target.value)}
            rows="5"
          />
          {fileName ? (
            <div className="mt-3">
              <MDBBtn color="danger" size="sm" onClick={() => { setFileName(''); setIsDeleting(true); }}>
                <MDBIcon icon="trash" className="mr-1" />
                Remover PDF
              </MDBBtn>
            </div>
          ) : (
            <div className="mt-3">
              <MDBFileInput
                textFieldTitle="Arquivo PDF"
                btnTitle="Inserir"
                btnColor="default"
                accept="application/pdf"
                getValue={(files) => handleFileChange(files[0])}
              />
            </div>
          )}
          {loadingFile ? (
            <MDBRow center className="align-items-center mt-2">
              <MDBSpinner className="mr-2" red />
              <span>Enviando</span>
            </MDBRow>
          ) : null}

        </MDBModalBody>
        <MDBModalFooter>
          <MDBBtn color="danger" size='sm' onClick={toggleEditModal}>
            Cancelar
          </MDBBtn>
          <MDBBtn color="success" size='sm' onClick={handleSaveEdit}>
            Salvar
          </MDBBtn>
        </MDBModalFooter>
      </MDBModal>

      <ModalRelatorioLeitura
        modalLeitura={abreModalRelatorio}
        setModalLeitura={setAbreModalRelatorio}
        pdf={PDFSelecionado}
      />
    </>
  );
};

export default function App() {
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [qtdTotal, setQtdTotal] = useState(0);
  const [qtdPorPagina, setQtdPorPagina] = useState({
    label: '10 registros',
    value: 10,
  });
  const [novoAssunto, setNovoAssunto] = useState('');
  const [relatos, setRelatos] = useState([]);
  const [modalAltera, setModalAltera] = useState(false);
  const [itemModal, setItemModal] = useState('');
  const [listaGerencias, setListaGerencias] = useState([]);
  const [gerenciaSelecionada, setGerenciaSelecionada] = useState({
    value: '',
    label: '',
  });
  const [dataInicio, setDataInicio] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [agentes, setAgentes] = useState([]);
  const [agenteSelecionado, setAgenteSelecionado] = useState('');

  const carregaSelects = () => {
    api
      .get('/agentes-inteligencia', {
        params: { ativo: true },
      })
      .then((agente) => {
        const agentesOptions = agente.data.map((element) => ({
          label: element.nome_social,
          value: element.id,
        }));
        setAgentes(agentesOptions);
      })
      .catch((error) => {
        console.error('Erro ao carregar agentes:', error);
        alert('Erro ao carregar agentes. Tente novamente.');
      });
  };

  const buscaAssuntos = async () => {
    setLoading(true);
    try {
      const params = {
        data_inicio: dataInicio,
        data_final: dataFinal,
        agente_id: agenteSelecionado,
        page: page,
        limit: qtdPorPagina.value,
      };

      const lista = await api.get('/relatos', { params });
      setQtdTotal(Math.ceil(Number(lista.data.count) / Number(qtdPorPagina.value)));
      const novaLista = lista.data.rows.map((element) => ({
        ...element,
        arrayRelato: element.relato.split('\n'),
      }));
      setRelatos(novaLista);
    } catch (error) {
      console.error('Erro ao buscar relatos:', error);
      alert('Erro ao buscar relatos. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdate = async (id) => {
    try {
      const response = await api.get(`/relatos/${id}`);
      const updatedRelato = response.data;
      setRelatos((prevRelatos) =>
        prevRelatos.map((item) =>
          item.id === id
            ? {
                ...item,
                relato: updatedRelato.relato,
                arrayRelato: updatedRelato.relato.split('\n'),
                relato_pdf: updatedRelato.relato_pdf,
                relato_pdf_id: updatedRelato.relato_pdf ? updatedRelato.relato_pdf.id : null,
              }
            : item
        )
      );
    } catch (error) {
      console.error('Erro ao buscar relato atualizado:', error);
      toast.error('Erro ao atualizar relato. Tente novamente.');
    }
  };

  const handleDelete = (id) => {
    setRelatos((prevRelatos) => prevRelatos.filter((item) => item.id !== id));
  };

  useEffect(() => {
    carregaSelects();
    buscaAssuntos();
  }, []);

  useEffect(() => {
    buscaAssuntos();
  }, [page, qtdPorPagina, dataInicio, dataFinal, agenteSelecionado]);

  return (
    <NavBar>
      <MDBContainer fluid className="p-0 m-0">
        <MDBRow className="h4-responsive" center>
          Relatório de Inteligência
        </MDBRow>
        <MDBRow center>
          <MDBCol size="12" md="3" className="mb-3 md-md-0">
            <div>Agente</div>
            <Select
              options={agentes}
              onChange={(e) => {
                setAgenteSelecionado(e ? e.value : '');
              }}
              placeholder="Agente"
              isClearable
            />
          </MDBCol>
          <MDBCol size="12" md="3">
            <span>Data Início</span>
            <MDBInput
              style={{ marginTop: '-28px' }}
              type="date"
              outline
              placeholder="Data Início"
              className="bg-white"
              onChange={(e) => setDataInicio(e.target.value ? parseISO(e.target.value) : '')}
            />
          </MDBCol>
          <MDBCol size="12" md="3">
            <div>Data Final</div>
            <MDBInput
              style={{ marginTop: '-28px' }}
              type="date"
              outline
              placeholder="Data Final"
              className="bg-white"
              onChange={(e) => setDataFinal(e.target.value ? parseISO(e.target.value) : '')}
            />
          </MDBCol>
          <MDBRow center>
            <MDBCol middle size="12">
              <MDBBtn
                disabled={loading}
                onClick={() => {
                  setPage(1);
                  buscaAssuntos();
                }}
              >
                Buscar
              </MDBBtn>
            </MDBCol>
          </MDBRow>
        </MDBRow>
        {loading ? (
          <MDBRow className="mt-5 text-center d-flex justify-content-center align-items-center">
            <MDBSpinner />
            <span className="ml-3 font-weight-bold">Carregando</span>
          </MDBRow>
        ) : relatos.length !== 0 ? (
          relatos.map((item) => (
            <CardRelato
              key={item.id}
              item={item}
              onUpdate={handleUpdate}
              onDelete={handleDelete}
            />
          ))
        ) : (
          <MDBRow center className="mt-5">
            <span className="font-weight-bold">Sem Dados</span>
          </MDBRow>
        )}
        <br />
        <MDBRow className="justify-content-center align-items-center">
          <MDBCol size="8" className="d-flex justify-content-center align-items-center">
            <MDBTooltip domElement tag="span" material placement="top">
              <span>
                <MDBIcon
                  className={`mx-3 ${page === 1 ? 'grey-text' : 'black-text cursor-pointer'}`}
                  onClick={() => {
                    if (page !== 1) setPage(1);
                  }}
                  style={{ fontSize: '30px' }}
                  icon="angle-double-left"
                />
              </span>
              <span>Primeira Página</span>
            </MDBTooltip>
            <span className="grey-text font-weight-bolder">|</span>
            <MDBTooltip domElement tag="span" material placement="top">
              <span>
                <MDBIcon
                  className={`mx-3 ${page === 1 ? 'grey-text' : 'black-text cursor-pointer'}`}
                  onClick={() => {
                    if (page !== 1) setPage(page - 1);
                  }}
                  style={{ fontSize: '30px' }}
                  icon="angle-left"
                />
              </span>
              <span>Página Anterior</span>
            </MDBTooltip>
            <div>
              Página {page} de {qtdTotal}
            </div>
            <MDBTooltip domElement tag="span" material placement="top">
              <span>
                <MDBIcon
                  className={`mx-3 ${page === qtdTotal ? 'grey-text' : 'black-text cursor-pointer'}`}
                  onClick={() => {
                    if (page < qtdTotal) setPage(page + 1);
                  }}
                  style={{ fontSize: '30px' }}
                  icon="angle-right"
                />
              </span>
              <span>Próxima página</span>
            </MDBTooltip>
            <span className="grey-text font-weight-bolder">|</span>
            <MDBTooltip domElement tag="span" material placement="top">
              <span>
                <MDBIcon
                  className={`mx-3 ${page === qtdTotal ? 'grey-text' : 'black-text cursor-pointer'}`}
                  onClick={() => {
                    if (page !== qtdTotal) setPage(qtdTotal);
                  }}
                  style={{ fontSize: '30px' }}
                  icon="angle-double-right"
                />
              </span>
              <span>Última página</span>
            </MDBTooltip>
          </MDBCol>
        </MDBRow>
        <br />
      </MDBContainer>
    </NavBar>
  );
}